var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMainNavPublisher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.999 2a.667.667 0 00-.623.415L7.48 6.9l-4.86.415a.678.678 0 00-.385 1.189l3.682 3.19-1.107 4.751a.678.678 0 001.01.734l4.18-2.52 4.181 2.52c.512.31 1.142-.15 1.008-.734l-1.108-4.767 3.686-3.189a.677.677 0 00-.39-1.185l-4.855-.415-1.896-4.474A.671.671 0 009.999 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainNavPublisher);
export default __webpack_public_path__ + "static/media/main-nav-publisher.88a0947d36611812f8503962d1cc6597.svg";
export { ForwardRef as ReactComponent };